import { render } from "./PaymentDetails.vue?vue&type=template&id=16600e3e&scoped=true"
import script from "./PaymentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetails.vue?vue&type=style&index=0&id=16600e3e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16600e3e"],['__file',"resources/js/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/PaymentDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16600e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16600e3e', __exports__)) {
    console.log('reload')
    api.reload('16600e3e', __exports__)
  }
  
  module.hot.accept("./PaymentDetails.vue?vue&type=template&id=16600e3e&scoped=true", () => {
    console.log('re-render')
    api.rerender('16600e3e', render)
  })

}


export default __exports__